var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0634 29.0016C22.1389 29.0016 28.7437 18.9972 28.7437 10.3213C28.7437 10.0372 28.7437 9.75431 28.7245 9.47269C30.0094 8.54325 31.1186 7.39256 32 6.07431C30.8018 6.60525 29.5306 6.95338 28.2291 7.10725C29.5994 6.287 30.6256 4.99588 31.1155 3.47588C29.8268 4.24056 28.4167 4.77956 26.9466 5.0695C25.7052 3.74944 23.9714 3 22.1595 3C18.5544 3 15.5879 5.9665 15.5879 9.5715C15.5879 10.0716 15.6451 10.5702 15.7581 11.0573C10.4819 10.7929 5.55931 8.29725 2.22719 4.19781C0.494437 7.18069 1.391 11.0463 4.25981 12.9619C3.21512 12.931 2.19287 12.6491 1.28 12.1402V12.2234C1.28087 15.3368 3.49544 18.0428 6.54719 18.6593C5.58069 18.9228 4.56638 18.9613 3.58275 18.7719C4.44069 21.4397 6.91469 23.2786 9.7165 23.3312C7.39213 25.1579 4.51919 26.1502 1.56288 26.1472C1.0405 26.1462 0.518625 26.1146 0 26.0525C3.00213 27.9791 6.49625 29.0013 10.0634 28.9965",
    fill: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.683916aec87d9b330255921aff4dcae1.svg";
export { ForwardRef as ReactComponent };